var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkerDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 0C5.37648 0 0.00390625 5.37258 0.00390625 12C0.00390625 18.6274 5.37648 24 12.0039 24C18.6313 24 24.0039 18.6274 24.0039 12C24.0039 5.37258 18.6313 0 12.0039 0ZM12.0039 22.5C6.20491 22.5 1.50391 17.799 1.50391 12C1.50391 6.201 6.20491 1.5 12.0039 1.5C17.8029 1.5 22.5039 6.201 22.5039 12C22.5039 17.799 17.8029 22.5 12.0039 22.5Z",
    fill: "#AAB8D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 13.5C12.8323 13.5 13.5039 12.8284 13.5039 12C13.5039 11.1716 12.8323 10.5 12.0039 10.5C11.1755 10.5 10.5039 11.1716 10.5039 12C10.5039 12.8284 11.1755 13.5 12.0039 13.5Z",
    fill: "#AAB8D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 13.5C18.0823 13.5 18.7539 12.8284 18.7539 12C18.7539 11.1716 18.0823 10.5 17.2539 10.5C16.4255 10.5 15.7539 11.1716 15.7539 12C15.7539 12.8284 16.4255 13.5 17.2539 13.5Z",
    fill: "#AAB8D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75391 13.5C7.58233 13.5 8.25391 12.8284 8.25391 12C8.25391 11.1716 7.58233 10.5 6.75391 10.5C5.92548 10.5 5.25391 11.1716 5.25391 12C5.25391 12.8284 5.92548 13.5 6.75391 13.5Z",
    fill: "#AAB8D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerDots);
export default __webpack_public_path__ + "static/media/workerDots.169a6cc0652d6eb460e913f35690856f.svg";
export { ForwardRef as ReactComponent };